import axios from 'axios'
import { Message } from 'element-ui'
import { server_url } from './config'
import { getBrowserFingerprintData, getFingerDevice } from '@/utils/fingerprint'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: server_url,
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  async config => {
    // 添加 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
      try {
        const { fingerprint } = await getBrowserFingerprintData()
        config.headers['fingerprint'] = fingerprint
        config.headers['Finger-Device'] = await getFingerDevice()
      } catch (error) {
        console.warn('[Fingerprint] 浏览器指纹采集失败:', error)
      }
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    } else if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json; charset=utf-8'
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.config && response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    // 根据业务状态码处理
    if (res.code === 400 || res.code === 401 || res.code === 411) {
      // token 过期或未授权
      localStorage.clear()
      Message.error(res.msg || '登录已过期，请重新登录')
      router.push({ path: '/login' })
      return Promise.reject(new Error(res.msg || '未授权'))
    }
    // if (res.code === 500) {
    //   Message.error(res.msg || '服务器错误')
    //   return Promise.reject(new Error(res.msg || '服务器错误'))
    // }
    return res
  },
  error => {
    console.log('响应错误:', error)
    console.error('响应错误:', error.message)
    Message.error('网络连接异常，请检查网络')
    return Promise.reject(error)
  }
)

// 封装 get/post 方法
export default {
  get(url, params, config = {}) {
    return new Promise((resolve, reject) => {
      service({
        method: 'get',
        url,
        params,
        ...config
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  post(url, data, config = {}) {
    return new Promise((resolve, reject) => {
      service({
        method: 'post',
        url,
        data,
        ...config
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}
